import { Component, ErrorInfo, ReactNode } from 'react'

interface IProps {
  children: ReactNode
  /** Shown in place of the children once they have thrown. Nothing, by default. */
  fallback?: ReactNode
  /** Told about the failure, for a caller that can do better than the fallback — remount, say. */
  onError?: (error: Error) => void
}

interface IState {
  hasFailed: boolean
}

/**
 * Contains a failure in a non-essential widget — a lazy chunk that didn't load on a bad
 * connection — so it can't reach the router's error page and replace the whole screen.
 */
class OptionalBoundary extends Component<IProps, IState> {
  state: IState = { hasFailed: false }

  static getDerivedStateFromError(): IState {
    return { hasFailed: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.warn('Optional component failed to render:', error, info.componentStack)
    this.props.onError?.(error)
  }

  render() {
    return this.state.hasFailed ? (this.props.fallback ?? null) : this.props.children
  }
}

export default OptionalBoundary
